import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    Table,
    TableContainer,
    Paper,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Slide
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[400],
    },
});

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});


class DetailsEmployeeDialog extends Component {

    closeDialog = () => {
        this.props.onClose();
    }

    render() {
        const { employeeAssets, employee } = this.props

        let employeeAssetsList;
        let recordsNotFound;
        if (employeeAssets && employeeAssets.length > 0) {
            employeeAssetsList = employeeAssets.map((employeeAsset, index) => {
                return <TableRow key={index}>
                    <TableCell>{employeeAsset.inventoryNumber}</TableCell>
                    <TableCell>{employeeAsset.typeOfEquipment}</TableCell>
                    <TableCell>{employeeAsset.startDate}</TableCell>
                    <TableCell>{employeeAsset.issuedBy}</TableCell>
                </TableRow >
            });
        } else {
            recordsNotFound = <TableRow>
                <TableCell align="center" colSpan={6}>
                    <p>{this.props.t("no_records_found")}</p>
                </TableCell>
            </TableRow>
        }

        return (
            <Dialog onClose={() => this.props.onClose()} open={this.props.isOpen} TransitionComponent={Transition} fullWidth maxWidth="md">
                <DialogTitle className="dialog-header-custom" onClose={this.props.onClose}>{employee && employee.firstName} {employee && employee.lastName} </DialogTitle>
                <DialogContent>
                    <Grid container direction="row" spacing={2}>
                        <Grid item container>
                            <TableContainer component={Paper}>
                                <Table aria-label="simple table" size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell component="th" scope="row" width="15%">{this.props.t("inventory_number")}</TableCell>
                                            <TableCell component="th" scope="row" width="30%">{this.props.t("name_of_equipment")}</TableCell>
                                            <TableCell component="th" scope="row" width="15%">{this.props.t("start_date")}</TableCell>
                                            <TableCell component="th" scope="row" width="30%">{this.props.t("issued_by")}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {employeeAssetsList}
                                        {recordsNotFound}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className={"dialog-actions-fix"}>
                    <Button color="inherit" onClick={() => this.props.exportToPdf()} variant="contained">
                        {this.props.t("pdf")}
                    </Button>
                    <Button color="primary" onClick={() => this.props.exportToDocx()} variant="contained">
                        {this.props.t("docx")}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withTranslation()(DetailsEmployeeDialog);